module.exports = __webpack_public_path__ + "img/zuijia_43.60a843db.png";